import Geral from "@/Pages/GestaoDeAulas/Geral.vue";
import GestaoDeAulasIndexPage from "@/Pages/GestaoDeAulas/index.vue";
import NewEditGestaoDeAulaPage from "@/Pages/GestaoDeAulas/NewEditGestaoDeAulaPage.vue";
import NewEditGestaoDeAulaPageGeral from "@/Pages/GestaoDeAulas/NewEditGestaoDeAulaPageGeral.vue";
import { can } from "@/plugins/can";
import { checkGestaoGuard } from "@/plugins/gestoesHelper";
import MetricasDaTurmaPolivalencia from "../Pages/GestaoDeAulas/dashboardPolivalencia.vue";

import MetricasDaTurma from "../Pages/GestaoDeAulas/dashboard.vue";
import Diario from "../Pages/GestaoDeAulas/Diario.vue";
import PlanoBimestralInfantil from "../Pages/GestaoDeAulas/planoBimestralInfantil.vue";
import PlanosBimestrais from "../Pages/GestaoDeAulas/planosBimestrais.vue";

const checkPermission = (permissions) => {
  return (to, from, next) => {
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

export default [
  {
    path: "/gestoes-de-aulas/",
    name: "gestoesDeAulas",
    component: GestaoDeAulasIndexPage,
    beforeEnter: (to, from, next) => {
      if (!can(["gestoesDeAulas.listar", "gestoesDeAulas.*"])) {
        return next({ name: "NaoAutorizado" });
      }
      return checkGestaoGuard("regular")(to, from, next);
    },
  },
  {
    path: "/gestoes-de-aulas/create",
    name: "gestoesDeAulas.create",
    component: NewEditGestaoDeAulaPage,
    props: { editing: false },
    beforeEnter: checkPermission(["gestoesDeAulas.criar", "gestoesDeAulas.*"]),
  },
  {
    path: "/gestoes-de-aulas/edit/:gestaoDeAulasId",
    name: "gestoesDeAulas.edit",
    component: NewEditGestaoDeAulaPage,
    props: { editing: true },
    beforeEnter: checkPermission(["gestoesDeAulas.atualizar", "gestoesDeAulas.*"]),
  },
  {
    path: "/gestoes-de-aulas/geral",
    name: "gestoesDeAulas.geral",
    component: Geral,
    beforeEnter: checkPermission(["gestoesDeAulas.*", "gestoesDeAulas.gestoesGeral"]),
  },
  {
    path: "/gestoes-de-aulas/geral/edit/:gestaoDeAulasId",
    name: "gestoesDeAulas.editGeral",
    redirect: { name: "gestoesDeAulas.geral" }, // Removido criação e edição na aba geral
  },
  {
    beforeEnter: checkPermission(["gestoesDeAulas.visualizar"]),
    component: PlanosBimestrais,
    name: "gestoesDeAulas.planoBimestralCreate",
    path: "/gestoes-de-aulas/:gestaoDeAulaId/plano-bimestral/:disciplinaId",
    props: { editing: false },
  },
  {
    beforeEnter: checkPermission(["gestoesDeAulas.visualizar"]),
    component: PlanoBimestralInfantil,
    name: "gestoesDeAulas.planoBimestralInfantil",
    path: "/gestoes-de-aulas/:gestaoDeAulaId/plano-bimestral-infantil",
    props: { editing: false },
  },
  {
    path: "/gestoes-de-aulas/:id/turma/metricas/:gestao",
    name: "gestoesDeAulas.metricasTurma",
    component: MetricasDaTurma,
    beforeEnter: checkPermission(["gestoesDeAulas.visualizar", "gestoesDeAulas.*"]),
  },
  {
    path: "/gestoes-de-aulas/diario",
    name: "gestoesDeAulas.diario",
    component: Diario,
    beforeEnter: checkPermission(["gestoesDeAulas.visualizar", "gestoesDeAulas.*"]),
  },
  {
    path: "/gestoes-de-aulas/:id/turma/metricas/:gestao/polivalencia",
    name: "gestoesDeAulas.metricasTurma.polivalencia",
    component: MetricasDaTurmaPolivalencia,
    beforeEnter: checkPermission(["gestoesDeAulas.visualizar", "gestoesDeAulas.*"]),
  },
];
